import { gql } from '@apollo/client';
const REMOVE_PRODUCT_VARIANT = gql `
  mutation RemoveProductVariant($productVariantId: ID!) {
    removeProductVariant(productVariantId: $productVariantId) {
      removed
    }
  }
`;
export default REMOVE_PRODUCT_VARIANT;
